import { render, staticRenderFns } from "./batm.vue?vue&type=template&id=526cc484"
import script from "./batm.vue?vue&type=script&lang=js"
export * from "./batm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports